// @flow
import React from 'react';
import { Text } from 'trpc-react-native-ui';
import { StyleSheet, View } from 'react-native';
import { Icon } from '../../../common/index';
import theme from '../../../../theme-config';

const getStyles = () =>
  StyleSheet.create({
    contact: {
      fontSize: 14,
    },
    icon: {
      color: theme.ui.colors.gray.normal,
      marginRight: 5,
    },
    inlineField: {
      flexDirection: 'row',
      justifyContent: 'flex-start',
    },
  });

const InlineIconText = ({ icon, text }: InlineIconTextProps) => {
  const styles = getStyles();
  return (
    <View style={styles.inlineField}>
      <Icon name={icon} size={15} style={styles.icon} />
      <Text style={styles.contact}>{text}</Text>
    </View>
  );
};

type InlineIconTextProps = {
  icon: string,
  text: string,
};

export default InlineIconText;
